// extracted by mini-css-extract-plugin
export default {"text":"index_text_3UNgL","firstText":"index_firstText_FeD3n","shortText":"index_shortText_MWj2R"};